document.addEventListener('DOMContentLoaded', function () {
  const allowedCountries = ['United States', 'Japan', 'South Korea'];

  document.querySelectorAll('select[name="address[country]"]').forEach(select => {
    [...select.options].forEach(option => {
      if (!allowedCountries.includes(option.text.trim())) {
        option.remove();
      }
    });

    if (!allowedCountries.includes(select.options[select.selectedIndex]?.text)) {
      select.selectedIndex = 0;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
});


document.querySelectorAll('summary[data-link]').forEach(sum => {
  sum.addEventListener('click', function (e) {
    if (e.target.tagName === 'SVG' || e.target.closest('svg')) return;
    window.location.href = this.dataset.link;
  });
});


function removeAllNotranslate() {
  document.querySelectorAll('.notranslate, [translate="no"]').forEach(el => {
    el.classList.remove('notranslate');
    el.removeAttribute('translate');
  });
}

document.addEventListener('DOMContentLoaded', () => {
  removeAllNotranslate();

  const notranslateObserver = new MutationObserver(() => {
    removeAllNotranslate();
  });

  notranslateObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});
(function () {
  const RATE_CACHE_PREFIX = 'exchange_rate_';
  const RATE_CACHE_TIME_PREFIX = 'exchange_rate_time_';
  const CACHE_DURATION_MS = 60 * 60 * 1000;

  const RATE_SOURCES = [
    'https://open.er-api.com/v6/latest/USD',
    'https://api.exchangerate-api.com/v4/latest/USD',
    'https://api.frankfurter.app/latest?from=USD'
  ];

  async function tryFetchRate(url, targetCurrency) {
    const response = await fetch(url);
    const data = await response.json();
    if (data.rates && data.rates[targetCurrency]) return data.rates[targetCurrency];
    throw new Error('No rate in response');
  }

  async function getExchangeRate(targetCurrency) {
    const cacheKey = RATE_CACHE_PREFIX + targetCurrency;
    const cacheTimeKey = RATE_CACHE_TIME_PREFIX + targetCurrency;
    const cachedRate = sessionStorage.getItem(cacheKey);
    const cachedTime = sessionStorage.getItem(cacheTimeKey);

    if (cachedRate && cachedTime && (Date.now() - parseInt(cachedTime) < CACHE_DURATION_MS)) {
      return parseFloat(cachedRate);
    }

    for (const url of RATE_SOURCES) {
      try {
        const rate = await tryFetchRate(url, targetCurrency);
        sessionStorage.setItem(cacheKey, rate);
        sessionStorage.setItem(cacheTimeKey, Date.now().toString());
        return rate;
      } catch (err) {
        console.warn('Rate source failed:', url, err);
      }
    }

    console.warn('All rate sources failed for', targetCurrency);
    const fallback = targetCurrency === 'JPY' ? 155 : 1450;
    return cachedRate ? parseFloat(cachedRate) : fallback;
  }

function getTargetCurrencyAndLabel() {
  const lang = document.documentElement.lang || 'en';
  if (lang.startsWith('ja')) return { currency: 'JPY', label: '約' };
  if (lang.startsWith('ko')) return { currency: 'KRW', label: '약' };
  return null; // English: no reference
}

  function formatMoney(amount, currency) {
    const locale = currency === 'JPY' ? 'ja-JP' : 'ko-KR';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      maximumFractionDigits: 0
    }).format(amount);
  }

async function injectReference() {
    const target = getTargetCurrencyAndLabel();
    if (!target) return;

    const { currency, label } = target;
    const rate = await getExchangeRate(currency);

    document.querySelectorAll('[data-usd-price]:not([data-krw-injected])').forEach(el => {
      const usdValue = parseFloat(el.getAttribute('data-usd-price'));
      if (isNaN(usdValue) || usdValue <= 0) return;

      const convertedValue = usdValue * rate;
      const refSpan = document.createElement('span');
      refSpan.style.opacity = '0.65';
      refSpan.style.fontSize = '0.85em';
      refSpan.style.marginLeft = '4px';
      refSpan.textContent = ` (${label} ${formatMoney(convertedValue, currency)})`;

      el.appendChild(refSpan);
      el.setAttribute('data-krw-injected', 'true');
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    injectReference();
    const observer = new MutationObserver(() => injectReference());
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
document.addEventListener("DOMContentLoaded", function() {
    const interval = setInterval(() => {
        const shopFollowBtn = document.querySelector('shop-follow-button');
        if (shopFollowBtn && shopFollowBtn.shadowRoot) {
            const btn = shopFollowBtn.shadowRoot.querySelector('button');
            if (btn) {
                btn.style.backgroundColor = '#fe7e12';
                // Agar hover state bhi change karni ho:
                btn.style.setProperty('background-color', '#fe7e12', 'important');
                clearInterval(interval);
            }
        }
    }, 500);
});